"use client";

import { Employer, GovernmentEmployerDocumentRegistrationDto } from "@entities/employer";
import { GovernmentEmployerDocumentDetails, GovernmentEmployerDocumentRegistrationForm } from "@features/registration";
import { Button, Dialog, DialogBody, DialogClose, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@ubud-ui/react-ui-kit";
import { useState } from "react";

function EditDialog({
  payload,
  onSubmit,
}: {
  payload?: GovernmentEmployerDocumentRegistrationDto | null;
  onSubmit?: (payload: GovernmentEmployerDocumentRegistrationDto) => void;
}) {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleSubmit = (data: GovernmentEmployerDocumentRegistrationDto) => {
    if (onSubmit) {
      setIsOpen(false);
      onSubmit(data);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => setIsOpen(open)}>
      <DialogTrigger asChild>
        <Button className="text-sm font-bold m-0 p-0 w-auto h-auto" variant="link">
          Ubah
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Edit dokumen pendukung</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <GovernmentEmployerDocumentRegistrationForm formValue={payload || undefined} onSubmit={handleSubmit}>
            <div className="sticky bottom-0 grid grid-cols-2 gap-3 bg-white py-6 mt-1">
              <DialogClose asChild>
                <Button className="text-sm font-bold" variant="outline">
                  Batal
                </Button>
              </DialogClose>
              <Button className="text-sm font-bold" variant="default">
                Simpan
              </Button>
            </div>
          </GovernmentEmployerDocumentRegistrationForm>
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
}

export function GovernmentEmployerDocumentRegistrationPreview({
  document,
  onSubmit,
}: {
  document?: GovernmentEmployerDocumentRegistrationDto | null;
  onSubmit?: (payload: GovernmentEmployerDocumentRegistrationDto) => void;
}) {
  return (
    <div>
      <div className="mb-4 flex items-center gap-4">
        <h4 className="flex-1 text-base font-bold">Dokumen pendukung</h4>
        <EditDialog payload={document} onSubmit={onSubmit} />
      </div>
      <GovernmentEmployerDocumentDetails
        employer={
          {
            employerable: {
              documents: document?.documents || [],
            },
          } as Employer
        }
      />
    </div>
  );
}
